import { lazy } from 'react';
const CycleCount = lazy(() => import('./cyclecount'));

const cyclecountRoutes = [
  {
    path: '/cyclecount',
    component: CycleCount
  }
];
export default cyclecountRoutes;